<template>
  <div>
    <button v-if="!loading" class="form-submit-button" @click="handleSubmit" :style="$styles.submitButton()">
      {{ text }}
    </button>
    <Spinner v-if="loading"></Spinner>
  </div>
</template>

<script>
import Spinner from '../utils/Spinner.vue'
export default {
  props: {
    text: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Spinner,
  },
  methods: {
    handleSubmit() {
      this.$emit('submit')
    },
  },
}
</script>

<style scoped>
.form-submit-button {
  width: 100%;
  font-weight: 600;
  border-radius: 6px;
  height: 40px;
  cursor: pointer;
  border: none;
  overflow: hidden;
  position: relative;
}

.form-submit-button:after {
  content: '';
  background: rgba(0, 0, 0, 0.4);
  display: block;
  position: absolute;
  padding-top: 300%;
  padding-left: 350%;
  margin-left: -20px !important;
  margin-top: -120%;
  opacity: 0;
  transition: all 0.8s;
}

.form-submit-button:active:after {
  padding: 0;
  margin: 0;
  opacity: 1;
  transition: 0s;
}
</style>
